const siderBar = {
  profile: "プロフィール",
  history: "履歴",
  setting: "設定",
  promotion: "プロモーション",
};

export default siderBar;